module.exports = __webpack_public_path__ + "img/mengceng.545f4cb7.png";